export const isImage = (file: File) => {
   if (!file) {
      return false;
   }

   return file.type.startsWith('image/');
};

export const isVideoType = (file: File) => {
   if (!file) {
      return false;
   }

   return file.type.startsWith('video/');
};

export enum FileSize {
   Favicon = 36 * 36,
   XS = 600 * 100,
   SM = 600 * 360,
   SMALL = 1024 * 1024,
   MEDIUM = 5 * 1024 * 1024,
   LARGE = 10 * 1024 * 1024,
   EXTRA_LARGE = 200 * 1024 * 1024,
}
